import React from "react";
import { func } from "prop-types";

import * as S from "./styled";

const tabItems = [
  {
    text: "Buy",
    value: "buy"
  },
  {
    text: "Sell",
    value: "sell"
  }
];

const BuyerSellerSwitch = ({ onChangeValue }) => (
  <S.Input
    labelText="I want to"
    name="buy_sell"
    onChangeValue={onChangeValue}
    required
    tabItems={tabItems}
    type="toggle"
  />
);

BuyerSellerSwitch.propTypes = {
  onChangeValue: func.isRequired
};

export default BuyerSellerSwitch;
